import generateNIncorrectChoicesGivenOneCorrect from "./generateThreeIncorrectChoices";
import getSubArrayOfChoices from "./getSubArrayOfChoices";




const generateTotalIncorrectChoices = <T>(
  correctChoices: any,
  data: T[],
  level: number
) => {
  const getRandomElementFromArray = (array: any) =>{
    return array[Math.floor(Math.random() * array.length)]
  }
  

  let arrayOfIncorrectChoices: any[] = [];

  //iterate through  array. For each element, generate three nonconflicting

  for (let i = 0; i < correctChoices.length; i++) {
    let temp: any = []
    const correctTier1 = correctChoices[i].tier1;
    const correctTier2 = correctChoices[i].tier2;
    const correctTier3 = correctChoices[i].tier3;
    const correctTier4 = correctChoices[i].tier4;


    if (level == 1){

      for (let i = 0; i < 3; i++){

        const tempTier1 = temp.map((accent: any) => accent.tier1)
        if (temp.length == 0){
          temp.push(getRandomElementFromArray(data.filter((accent: any) => accent.tier1 != correctTier1)))
        }else{
          temp.push(getRandomElementFromArray(data.filter((accent: any) => accent.tier1 != correctTier1 && !tempTier1.includes(accent.tier1))))
        }
      }
    }else if (level == 2){

      const correctGrouped = Math.round(Math.random());
      if (correctGrouped == 1){
        const incorrectChoice1 = getRandomElementFromArray(data.filter((accent: any) => accent.tier1 == correctTier1 && accent.tier2 != correctTier2))
        temp.push(incorrectChoice1)

        const incorrectChoice2 = getRandomElementFromArray(data.filter((accent: any) => accent.tier1 != correctTier1))
        temp.push(incorrectChoice2)
        
        const tempTier1 = temp.map((accent: any) => accent.tier1)
        const incorrectChoice3 = getRandomElementFromArray(data.filter((accent: any) => !tempTier1.includes(accent.tier1)))
        temp.push(incorrectChoice3)

      }else{
        const incorrectChoice1 = getRandomElementFromArray(data.filter((accent: any) => accent.tier1 != correctTier1))
        temp.push(incorrectChoice1)

        const incorrectChoice2 = getRandomElementFromArray(data.filter((accent: any) => accent.tier1 == temp[0].tier1 && accent.tier2 != temp[0].tier2))
        temp.push(incorrectChoice2)

        const incorrectChoice3 = getRandomElementFromArray(data.filter((accent: any) => accent.tier1 != correctTier1 && accent.tier1 != temp[0].tier1))
        temp.push(incorrectChoice3)
      }
    }else if (level == 3){

      const incorrectChoice1 = getRandomElementFromArray(data.filter((accent: any) => accent.tier1 == correctTier1 && accent.tier2 != correctTier2))
      temp.push(incorrectChoice1)

      const incorrectChoice2 = getRandomElementFromArray(data.filter((accent: any) => accent.tier1 != correctTier1))
      temp.push(incorrectChoice2)

      const incorrectChoice3 = getRandomElementFromArray(data.filter((accent: any) => accent.tier1 == temp[1].tier1 && accent.tier2 != temp[1].tier2))
      temp.push(incorrectChoice3)

    }else if (level == 4){
      const incorrectChoice1 = getRandomElementFromArray(data.filter((accent: any) => accent.city != "" && accent.tier1 == correctTier1 && accent.tier4 != correctTier4))
      temp.push(incorrectChoice1)

      const incorrectChoice2 = getRandomElementFromArray(data.filter((accent: any) => accent.city != "" && accent.tier1 == correctTier1 && accent.tier4 != correctTier4 && accent.tier4 != temp[0].tier4))
      temp.push(incorrectChoice2)


      const tempTier4 = temp.map((accent: any) => accent.tier4)
      const incorrectChoice3 = getRandomElementFromArray(data.filter((accent: any) => accent.city != "" && accent.tier1 == correctTier1 && accent.tier4 != correctTier4 && !tempTier4.includes(accent.tier4)))
      temp.push(incorrectChoice3)

      for (let j = 0; j < 3; j++){
        if (temp[i] === undefined){

          temp = []
          const incorrectChoice1 = getRandomElementFromArray(data.filter((accent: any) => accent.tier1 == correctTier1 && accent.tier2 != correctTier2))
          temp.push(incorrectChoice1)

          const incorrectChoice2 = getRandomElementFromArray(data.filter((accent: any) => accent.tier1 != correctTier1))
          temp.push(incorrectChoice2)

          const incorrectChoice3 = getRandomElementFromArray(data.filter((accent: any) => accent.tier1 == temp[1].tier1 && accent.tier2 != temp[1].tier2))
          temp.push(incorrectChoice3)
          break
        }
      }

    }else if (level == 5){

      const incorrectChoice1 = getRandomElementFromArray(data.filter((accent: any) => accent.city != "" && accent.tier2 == correctTier2 && accent.tier3 != correctTier3))
      temp.push(incorrectChoice1)

      const incorrectChoice2 = getRandomElementFromArray(data.filter((accent: any) => accent.city != "" && accent.tier1 == correctTier1 && accent.tier2 != correctTier2))
      temp.push(incorrectChoice2)

      const incorrectChoice3 = getRandomElementFromArray(data.filter((accent: any) => accent.city != "" && accent.tier2 == temp[1].tier2 && accent.tier3 != temp[1].tier3))
      temp.push(incorrectChoice3)

      for (let j = 0; j < 3; j++){
        if (temp[i] === undefined){
          temp = []
          const incorrectChoice1 = getRandomElementFromArray(data.filter((accent: any) => accent.tier1 == correctTier1 && accent.tier2 != correctTier2))
          temp.push(incorrectChoice1)

          const incorrectChoice2 = getRandomElementFromArray(data.filter((accent: any) => accent.tier1 != correctTier1))
          temp.push(incorrectChoice2)

          const incorrectChoice3 = getRandomElementFromArray(data.filter((accent: any) => accent.tier1 == temp[1].tier1 && accent.tier2 != temp[1].tier2))
          temp.push(incorrectChoice3)
          break
        }
      }
    }

    arrayOfIncorrectChoices = arrayOfIncorrectChoices.concat(temp)

  }
  
  return arrayOfIncorrectChoices;
};

export default generateTotalIncorrectChoices;
